import React, { Component } from 'react';
import SearchMemberTypeAhead from '../../Components/Search-Member-Type-Ahead/Search-Member-Type-Ahead';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import DivPermission from '../../Components/Div-Permission/Div-Permission';
import Usuario from '../../Utils/Usuario';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import update from 'immutability-helper';
import "./Unification.scss";



class Unification extends Component {

    constructor(props) {
        super(props);

        this.getMembroSelecionado = this.getMembroSelecionado.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.removerMembro = this.removerMembro.bind(this);
        this.exibirDadosCadastrais = this.exibirDadosCadastrais.bind(this);
        this.toggleModalUsuarioCadastrado = this.toggleModalUsuarioCadastrado.bind(this);
        this.unificarCadastros = this.unificarCadastros.bind(this);
        this.handleError = this.handleError.bind(this);
        this.toggleModalSucessoUnificacao = this.toggleModalSucessoUnificacao.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.toggleModalExibirMensagem = this.toggleModalExibirMensagem.bind(this);
        this.reiniciar = this.reiniciar.bind(this);
        this.funcaoStatusInicial = this.funcaoStatusInicial.bind(this);

        this.state = {
            listaUsuarios: [],
            isLoadingExibir: false,
            usuarios: [],
            isLoadingUnificar: false,
            usersNameList: [],
            cpfList: [],
            hasError: false,
            errorMessage: '',
            modalUsuarioCadastrado: false,
            telefoneList: [],
            modalSucessoUnificacao: false,
            modalExibirMensagem: false,
            flagDadosExibidos: false,
            arrayCores: [
                {
                    badgeColor: 'pink',
                    textInsideColor: 'white',
                    flagDisponivel: true,
                    id: 1,
                    hexaBadge: "#e83e8c",
                    hexaText: "#fff"
                },
                {
                    badgeColor: 'purple',
                    textInsideColor: 'white',
                    flagDisponivel: true,
                    id: 2,
                    hexaBadge: "#6f42c1",
                    hexaText: "#fff"
                },
                {
                    badgeColor: 'orange',
                    textInsideColor: 'white',
                    flagDisponivel: true,
                    id: 3,
                    hexaBadge: "#fd7e14",
                    hexaText: "#fff"
                },
                {
                    badgeColor: 'lightblue',
                    textInsideColor: 'dark',
                    flagDisponivel: true,
                    id: 4,
                    hexaBadge: "rgb(135, 194, 229)",
                    hexaText: "#000"
                },
                {
                    badgeColor: 'lightgreen',
                    textInsideColor: 'dark',
                    flagDisponivel: true,
                    id: 5,
                    hexaBadge: "rgb(135, 229, 177)",
                    hexaText: "#000"
                },
            ]
        }
        this.Configurations = new Configurations();


    }



    componentWillMount() {
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const foundUnification = roles.some(r => [1, 30].indexOf(r) >= 0);
        if (!foundUnification) {
            this.props.history.push({ pathname: '/permissao-negada' });
        }
    }

    funcaoStatusInicial() {
        const statusInicial = {
            usersNameListOptions: [],
            cpfListOptions: [],
            emailListOptions: [],
            divisaoListOptions: [],
            codMembroListOptions: [],
            blocoListOptions: [],
            telefoneListOptions: [],
            enderecoListOptions: [],
        }
        this.setState({ ...this.state, statusInicial });
    }

    getMembroSelecionado(membro) {

        if (this.state.flagDadosExibidos) {
            return;
        }

        if (this.state.listaUsuarios.some(item => item.idUsuario === membro.idUsuario)) {
            this.toggleModalUsuarioCadastrado();
        } else {
            const listaUsuariosAux = this.state.listaUsuarios;
            const indexCor = this.state.arrayCores.findIndex(item => item.flagDisponivel === true);
            listaUsuariosAux.push({ ...membro, color: this.state.arrayCores[indexCor] });
            this.setState({
                listaUsuarios: listaUsuariosAux,
                arrayCores: update(this.state.arrayCores, { [indexCor]: { flagDisponivel: { $set: false } } })
            })
        }
    }

    toggleModalUsuarioCadastrado() {
        this.setState({ modalUsuarioCadastrado: !this.state.modalUsuarioCadastrado })
    }

    removerMembro(index, id) {
        const indexCor = this.state.arrayCores.findIndex(item => item.id === id);
        const novaListaUsuarios = this.state.listaUsuarios.slice();
        novaListaUsuarios.splice(index, 1);
        this.setState({
            listaUsuarios: novaListaUsuarios,
            arrayCores: update(this.state.arrayCores, { [indexCor]: { flagDisponivel: { $set: true } } })
        })
    }

    exibirDadosCadastrais() {
        const listaIdsUsuarios = this.state.listaUsuarios.map(usuario => usuario.idUsuario);
        const _body = {
            usuarios: listaIdsUsuarios
        };

        if (this.state.listaUsuarios.length > 1) {
            this.setState({ isLoadingExibir: true });

            axios.post(this.Configurations.apiBasePath + `/usuarios/duplicidade`, _body).then(response => {
                const usersNameListOptions = response.data.cadastroUsuarios.map((item, index) => {
                    const nome = item.nome ? item.nome : '-';
                    const label = `${nome}`;
                    const indexUsuario = this.state.listaUsuarios.findIndex(itemUsuario => itemUsuario.idUsuario === item.idUsuario);
                    return {
                        label: label,
                        value: item.idUsuario,
                        id: "nome",
                        color: this.state.listaUsuarios[indexUsuario].color,
                    }
                })

                const cpfListOptions = response.data.cadastroUsuarios.map(item => {
                    const cpf = item.cpf ? item.cpf : '-';
                    const label = `${cpf}`;
                    const indexUsuario = this.state.listaUsuarios.findIndex(itemUsuario => itemUsuario.idUsuario === item.idUsuario);

                    return {
                        label: label,
                        value: item.idUsuario,
                        id: "cpf",
                        color: this.state.listaUsuarios[indexUsuario].color,

                    }
                })
                const emailListOptions = response.data.cadastroUsuarios.map(item => {
                    const email = item.email ? item.email : '-';
                    const label = `${email}`;
                    const indexUsuario = this.state.listaUsuarios.findIndex(itemUsuario => itemUsuario.idUsuario === item.idUsuario);

                    return {
                        label: label,
                        value: item.idUsuario,
                        id: "email",
                        color: this.state.listaUsuarios[indexUsuario].color,

                    }
                })
                const divisaoListOptions = response.data.cadastroUsuarios.map(item => {
                    const divisao = item.divisao ? item.divisao : '-';
                    const label = `${divisao}`;
                    const indexUsuario = this.state.listaUsuarios.findIndex(itemUsuario => itemUsuario.idUsuario === item.idUsuario);

                    return {
                        label: label,
                        value: item.idUsuario,
                        id: "divisao",
                        color: this.state.listaUsuarios[indexUsuario].color,
                    }
                })
                const codMembroListOptions = response.data.cadastroUsuarios.map(item => {
                    const codMembro = item.codMembro ? item.codMembro : '-';
                    const label = `${codMembro}`;
                    const indexUsuario = this.state.listaUsuarios.findIndex(itemUsuario => itemUsuario.idUsuario === item.idUsuario);

                    return {
                        label: label,
                        value: item.idUsuario,
                        id: "codMembro",
                        color: this.state.listaUsuarios[indexUsuario].color,
                    }
                })
                const blocoListOptions = response.data.cadastroUsuarios.map(item => {
                    const organizacao = item.bloco ? item.bloco : '-';
                    const label = `${organizacao}`;
                    const indexUsuario = this.state.listaUsuarios.findIndex(itemUsuario => itemUsuario.idUsuario === item.idUsuario);

                    return {
                        label: label,
                        value: item.idUsuario,
                        id: "bloco",
                        color: this.state.listaUsuarios[indexUsuario].color,
                    }
                })

                const telefoneListOptions = response.data.cadastroUsuarios.map(item => {
                    const indexUsuario = this.state.listaUsuarios.findIndex(itemUsuario => itemUsuario.idUsuario === item.idUsuario);
                    return item.telefone.length ?
                        item.telefone.map(telefone => ({
                            label: telefone.telefone,
                            value: telefone.idTelefone,
                            id: "telefone",
                            color: this.state.listaUsuarios[indexUsuario].color,
                        })) :
                        [{
                            label: '-',
                            value: null,
                            id: "telefone",
                            color: this.state.listaUsuarios[indexUsuario].color,
                        }];
                }).flat();


                const enderecoListOptions = response.data.cadastroUsuarios.map(item => {

                    const indexUsuario = this.state.listaUsuarios.findIndex(itemUsuario => itemUsuario.idUsuario === item.idUsuario);
                    const logradouro = item.logradouro ? item.logradouro : '-';
                    const numero = item.numero ? item.numero : '-';
                    const bairro = item.bairro ? item.bairro : '-';
                    const cidade = item.cidade ? item.cidade : '-';
                    const uf = item.uf ? item.uf : '-';
                    const complemento = item.complemento ? item.complemento : '-';
                    const cep = item.cep ? item.cep : '-';
                    // const principal = item.principal === true ? " - (PADRÃO)" : "";
                    // const label = `${logradouro}, ${numero} - ${bairro} - ${cidade}/${uf} - ${complemento} - ${cep}${principal}`;
                    const label = `${logradouro}, ${numero} - ${bairro} - ${cidade}/${uf} - ${complemento} - ${cep}`;
                    return {
                        label: label,
                        value: item.idEndereco,
                        id: "endereco",
                        color: this.state.listaUsuarios[indexUsuario].color,

                    };

                });


                this.setState({
                    usuarios: this.state.listaUsuarios,
                    usersNameListOptions: usersNameListOptions,
                    cpfListOptions: cpfListOptions,
                    emailListOptions: emailListOptions,
                    divisaoListOptions: divisaoListOptions,
                    codMembroListOptions: codMembroListOptions,
                    blocoListOptions: blocoListOptions,
                    telefoneListOptions: telefoneListOptions,
                    enderecoListOptions: enderecoListOptions,
                    flagDadosExibidos: true,
                })
            }).catch(this.handleError).finally(() => this.setState({ isLoadingExibir: false }));
        } else
            this.toggleModalExibirMensagem();
    }

    toggleModalExibirMensagem() {
        this.setState({ modalExibirMensagem: !this.state.modalExibirMensagem })
    }

    handleChange(newValue, actionMeta) {
        const name = actionMeta.name;
        let _valor;

        switch (actionMeta.action) {
            case "clear":
                _valor = null;
                break;
            case "select-option":
                if (Array.isArray(newValue)) {
                    _valor = newValue.map(option => ({
                        value: option.value,
                        label: option.label,
                        id: option.id
                    }));
                } else if (newValue) {
                    _valor = { value: newValue.value, label: newValue.label, id: newValue.id };
                } else {
                    _valor = null;
                }
                break;
            case "create-option":
                if (newValue && newValue.label !== undefined) {
                    _valor = { label: newValue.label };
                } else {
                    _valor = null;
                }
                break;
            default:
                _valor = null;
                break;
        }
        this.setState({ [name]: _valor });
    }


    handleError(err) {
        this.setState({
            hasError: true, errorMessage: (err.response && err.response.data && !!err.response.data.message) ?
                err.response.data.message : 'Erro inesperado.'
        })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    unificarCadastros() {
        const _body = {
            usuarios: this.state.listaUsuarios.map(usuario => usuario.idUsuario),
            nome: { idUsuario: this.state.usersNameList.value },
            cpf: { idUsuario: this.state.cpfList.value },
            email: { idUsuario: this.state.emailList.value },
            divisao: { idUsuario: this.state.divisaoList.value },
            organizacao: { idUsuario: this.state.blocoList.value },
            telefone: { idTelefone: this.state.telefoneList && this.state.telefoneList.map(item => item.value) },
            endereco: { idEndereco: this.state.enderecoList && this.state.enderecoList.map(end => end.value) }
        }

        this.setState({ isLoadingUnificar: true })
        axios.put(this.Configurations.apiBasePath + `/usuarios/duplicidade/unificar`, _body).then(response => {
            this.setState({
                idUsuario: response.data.idUsuario
            })
            this.toggleModalSucessoUnificacao();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingUnificar: false }));
    }

    toggleModalSucessoUnificacao() {
        this.setState({ modalSucessoUnificacao: !this.state.modalSucessoUnificacao })
    }

    reiniciar() {
        this.funcaoStatusInicial();
        this.setState({
            usuarios: [],
            flagDadosExibidos: false,
        })
    }

    render() {
        return (
            <div className='row unificacao py-2'>
                <div className='col-12'>
                    <div className='row no-gutters border-bottom border-dark'>
                        <div className='col-12 text-left '>
                            <h4>Unificação de cadastro</h4>
                        </div>
                    </div>
                    <div className='row py-4'>
                        <div className='col-6'>
                            <div className="row no-gutters">
                                <div className="col-12 pt-2 pb-1">
                                    <p className="m-0">Selecione todos os cadastros duplicados para unificação:</p>
                                </div>
                                <div className="col-12 py-1">
                                    <SearchMemberTypeAhead
                                        coordPeriodicos={true}
                                        getMembroSelecionado={this.getMembroSelecionado}
                                        onSearch={query => {
                                            this.setState({ isLoading: true });
                                            axios.get(this.configurations.apiBasePath + `/busca?query=${query}`)
                                                .then(resp => {
                                                    if (resp.data && (resp.data.orders || resp.data.users)) {
                                                        this.setState({
                                                            isLoading: false,
                                                            options: resp.data.orders.length > 0 ? resp.data.orders : resp.data.users,
                                                        });
                                                    }
                                                });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <React.Fragment>
                        <div className='row'>
                            <div className='col-6'>
                                <h4 className='m-0'>
                                    {this.state.listaUsuarios.map((item, index) => {
                                        return (
                                            <div key={index} className='col-12 pb-2'>
                                                <div className='d-flex align-items-center'>
                                                    <span className={`badge badge-${item.color.badgeColor} text-${item.color.textInsideColor} mr-2`}>{item.nome} ({item.codMembro ? item.codMembro : "Sem cód. membro"})
                                                    </span>
                                                    {!this.state.flagDadosExibidos && (
                                                        <span className='cursor-pointer mr-2' onClick={() => this.removerMembro(index, item.color.id)} style={{ fontSize: 16 }} >
                                                            <i className={`far fa-trash-alt text-danger`}></i>
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </h4>
                            </div>
                            <div className='col-4 text-right'>
                                {this.state.listaUsuarios.length > 0 && (
                                    <React.Fragment>
                                        {this.state.isLoadingExibir ? (
                                            <div className="row">
                                                <div className="col-12 text-center">
                                                    <div className="spinner-border text-primary mx-3 text-center" />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className='row'>
                                                <div className='col-12 text-center'>
                                                    {this.state.flagDadosExibidos ? (
                                                        <button className='btn btn-outline-primary' onClick={this.reiniciar}>Reiniciar</button>
                                                    ) : (
                                                        <button className='btn btn-outline-success' onClick={this.exibirDadosCadastrais}>exibir dados cadastrais</button>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </React.Fragment>
                                )}
                            </div>
                        </div>



                        <div className='row py-3' >
                            <div className='col-12'>
                                {this.state.usuarios.length > 1 && (
                                    <div className='card'>
                                        <div className='card-header'>
                                            Dados do usuário
                                        </div>
                                        <div className='card-body'>
                                            <h5 className='text-success'>Selecione as informações que devem permanecer no cadastro</h5>
                                            <div className='row py-2'>
                                                <div className='col-4'>
                                                    <div className="form-group">
                                                        <label htmlFor="nomeUsuario"><strong>Nome </strong></label>
                                                        <Select
                                                            id="nomeUsuario"
                                                            placeholder="Selecione um nome"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.usersNameList}
                                                            name="usersNameList"
                                                            onChange={this.handleChange}
                                                            options={this.state.usersNameListOptions}
                                                            styles={{
                                                                option: (styles, { data }) => {
                                                                    return ({ ...styles, backgroundColor: data.color.hexaBadge, color: data.color.hexaText })
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-4'>
                                                    <div className="form-group">
                                                        <label htmlFor="codMembro"><strong>Cód.membro</strong></label>
                                                        <Select
                                                            id="codMembro"
                                                            placeholder="Selecione o código de membro"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.codMembroList}
                                                            name="codMembroList"
                                                            onChange={this.handleChange}
                                                            options={this.state.codMembroListOptions}
                                                            styles={{
                                                                option: (styles, { data }) => {
                                                                    return ({ ...styles, backgroundColor: data.color.hexaBadge, color: data.color.hexaText })
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-4'>
                                                    <DivPermission
                                                        arrayPerm={[1, 30]}
                                                        permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                    >
                                                        <div className="form-group">
                                                            <label htmlFor="cpfUsuario"><strong>CPF</strong></label>
                                                            <Select
                                                                id="cpfUsuario"
                                                                placeholder="Selecione um CPF"
                                                                closeMenuOnSelect={true}
                                                                components={makeAnimated()}
                                                                defaultValue={this.state.cpfList}
                                                                name="cpfList"
                                                                onChange={this.handleChange}
                                                                options={this.state.cpfListOptions}
                                                                styles={{
                                                                    option: (styles, { data }) => {
                                                                        return ({ ...styles, backgroundColor: data.color.hexaBadge, color: data.color.hexaText })
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </DivPermission>
                                                </div>

                                            </div>
                                            <div className='row py-3'>
                                                <div className='col-4'>
                                                    <div className="form-group">
                                                        <label htmlFor="divisao"><strong>Divisão</strong></label>
                                                        <Select
                                                            id="divisao"
                                                            placeholder="Selecione uma divisão"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.divisaoList}
                                                            name="divisaoList"
                                                            onChange={this.handleChange}
                                                            options={this.state.divisaoListOptions}
                                                            styles={{
                                                                option: (styles, { data }) => {
                                                                    return ({ ...styles, backgroundColor: data.color.hexaBadge, color: data.color.hexaText })
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                </div>
                                                <div className='col-4'>
                                                    <div className="form-group">
                                                        <label htmlFor="email"><strong>Email</strong></label>
                                                        <Select
                                                            id="email"
                                                            placeholder="Selecione um email"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.emailList}
                                                            name="emailList"
                                                            onChange={this.handleChange}
                                                            options={this.state.emailListOptions}
                                                            styles={{
                                                                option: (styles, { data }) => {
                                                                    return ({ ...styles, backgroundColor: data.color.hexaBadge, color: data.color.hexaText })
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-4'>
                                                    <div className="form-group">
                                                        <label htmlFor="email"><strong>Bloco</strong></label>
                                                        <Select
                                                            id="bloco"
                                                            placeholder="Selecione um bloco"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.blocoList}
                                                            name="blocoList"
                                                            onChange={this.handleChange}
                                                            options={this.state.blocoListOptions}
                                                            styles={{
                                                                option: (styles, { data }) => {
                                                                    return ({ ...styles, backgroundColor: data.color.hexaBadge, color: data.color.hexaText })
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-4 py-3'>
                                                    <div className="form-group">
                                                        <label htmlFor="telefone"><strong>Telefone</strong></label>
                                                        <Select
                                                            id="telefone"
                                                            placeholder="Selecione um ou mais telefones"
                                                            isMulti
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.telefoneList}
                                                            name="telefoneList"
                                                            onChange={this.handleChange}
                                                            options={this.state.telefoneListOptions}
                                                            styles={{
                                                                option: (styles, { data }) => {
                                                                    return ({ ...styles, backgroundColor: data.color.hexaBadge, color: data.color.hexaText })
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-8 py-3'>
                                                    <div className="form-group">
                                                        <label htmlFor="endereco"><strong>Endereço</strong></label>
                                                        <Select
                                                            id="endereco"
                                                            isMulti
                                                            placeholder="Selecione um endereço"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.enderecoList}
                                                            name="enderecoList"
                                                            onChange={this.handleChange}
                                                            options={this.state.enderecoListOptions}
                                                            styles={{
                                                                option: (styles, { data }) => {
                                                                    return ({ ...styles, backgroundColor: data.color.hexaBadge, color: data.color.hexaText })
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <p className='m-0'><small>O primeiro endereço selecionado será considerado como padrão</small></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </React.Fragment>
                    <div className='row'>
                        <div className='col-12 text-center'>
                            {this.state.usuarios.length > 1 && (
                                <div className='row py-4'>
                                    <div className='col-12 text-center'>
                                        {this.state.isLoadingUnificar ? (
                                            <div className="row">
                                                <div className="col-12 text-center">
                                                    <div className="spinner-border text-primary mx-3 text-center" />
                                                </div>
                                            </div>
                                        ) : (
                                            <button className='btn btn-outline-info' onClick={this.unificarCadastros}>unificar cadastros</button>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.modalUsuarioCadastrado} toggle={this.toggleModalUsuarioCadastrado}>
                    <ModalHeader toggle={this.toggleModalUsuarioCadastrado}>Aviso</ModalHeader>
                    <ModalBody>
                        <p className='m-0 text-center text-danger'><strong>Usuário já cadastrado</strong></p>
                    </ModalBody>
                    <ModalFooter>
                        <div className='row'>
                            <div className='col-12 text-right'>
                                <button className='btn btn-outline-success' onClick={this.toggleModalUsuarioCadastrado}>ok</button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modalSucessoUnificacao} toggle={this.toggleModalSucessoUnificacao}>
                    <ModalHeader toggle={() => this.props.history.push(`/assinante/${this.state.idUsuario}`)}>Unificação de cadastros</ModalHeader>
                    <ModalBody>
                        <p className='m-0 text-center text-success'><i><strong>Unificação concluída com sucesso!</strong></i></p>
                    </ModalBody>
                    <ModalFooter>
                        <div className='row'>
                            <div className='col-12 text-right'>
                                <button className='btn btn-outline-success' onClick={() => this.props.history.push(`/assinante/${this.state.idUsuario}`)}>ok</button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modalExibirMensagem} toggle={this.toggleModalExibirMensagem}>
                    <ModalHeader toggle={this.toggleModalExibirMensagem}>Aviso</ModalHeader>
                    <ModalBody>
                        <p className='m-0 text-center text-purple'><strong>Para prosseguir selecione pelo menos 2 cadastros</strong></p>
                    </ModalBody>
                    <ModalFooter>
                        <div className='row'>
                            <div className='col-12 text-right'>
                                <button className='btn btn-outline-success' onClick={this.toggleModalExibirMensagem}>ok</button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={!this.state.hasError}
                />
            </div >
        )
    }
}
export default Unification;
